import { useContext } from 'react';
import { UserContext } from '../context/user-context';

const useUserContext = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUserContext must be used within a UserContext');
  }
  return context;
};
export default useUserContext;
